import {
    DisbursementBeneficiaryType,
    DisbursementFundsTransferMode,
} from "../../../api/disbursements";


export const DISBURSEMENT_BENEFICIARY_TYPE_LABELS: Record<
    DisbursementBeneficiaryType,
    string
> = {
    [DisbursementBeneficiaryType.BORROWER]: "Borrower",
    [DisbursementBeneficiaryType.SELLER]: "Seller",
    [DisbursementBeneficiaryType.DEVELOPER]: "Developer",
    [DisbursementBeneficiaryType.MERCHANT]: "Merchant",
    [DisbursementBeneficiaryType.INSTITUTION]: "Institution",
    [DisbursementBeneficiaryType.INSURER]: "Insurer",
    [DisbursementBeneficiaryType.ESCROW_OR_PARTNER]: "Escrow or Partner",
    [DisbursementBeneficiaryType.OTHER]: "Other",
};


export const DISBURSEMENT_FUNDS_TRANSFER_MODE_LABELS: Record<
    DisbursementFundsTransferMode,
    string
> = {
    [DisbursementFundsTransferMode.NEFT]: "NEFT",
    [DisbursementFundsTransferMode.RTGS]: "RTGS",
    [DisbursementFundsTransferMode.IMPS]: "IMPS",
    [DisbursementFundsTransferMode.ACCOUNT_PAYEE_CHEQUE]: "Account Payee Cheque",
    [DisbursementFundsTransferMode.INTERNAL_TRANSFER]: "Internal Transfer",
    [DisbursementFundsTransferMode.DEMAND_DRAFT]: "Demand Draft",
    [DisbursementFundsTransferMode.UPI]: "UPI",
    [DisbursementFundsTransferMode.OTHER]: "Other",
};


export const DISBURSEMENT_BENEFICIARY_TYPE_OPTIONS = Object.values(
    DisbursementBeneficiaryType,
  ).map((value) => ({
    value,
    name: DISBURSEMENT_BENEFICIARY_TYPE_LABELS[value],
}));


export const DISBURSEMENT_FUNDS_TRANSFER_MODE_OPTIONS = Object.values(
    DisbursementFundsTransferMode,
  ).map((value) => ({
    value,
    name: DISBURSEMENT_FUNDS_TRANSFER_MODE_LABELS[value],
}));